import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

export default class DynamicSlideshow {
  constructor({ el }) {
    this.$el = $(el);
    this.initializedClass = 'slideshow-initialized';
    this._bindEvents();
    this.timeouts = [];
    this._validate();
  }

  _bindEvents() {
    this.events = [
      $('.previous-slide', this.$el).on('click.slideshow', event => this.previousSlide(event)),
      $('.next-slide', this.$el).on('click.slideshow', event => this.nextSlide(event)),
      $('.slideshow-pagination > span', this.$el).on('click.slideshow', event => this.specificSlide(event)),
      this.$el.on('mouseenter.slideshow', event => this.pauseLoop(event)),
      this.$el.on('mouseleave.slideshow', event => this.startLoop(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.slideshow'));
  }

  update($el) {
    this.$el = $el;
    this._validate();
  }

  _validate() {
    this.navigation = $('.slideshow-navigation', this.$el);
    this.pagination = $('.slideshow-pagination', this.$el);
    this.autoplay = parseInt($('.home-slideshow', this.$el).attr('data-slideshow-autoplay'), 10);

    this.setWindowWidth();
    this.setupSlides();

    this.transitionend = (function (transition) {
      const transEndEventNames = {
        '-webkit-transition': 'webkitTransitionEnd',
        '-moz-transition': 'transitionend',
        '-o-transition': 'oTransitionEnd',
        transition: 'transitionend',
      };

      return transEndEventNames[transition];
    }(Modernizr.prefixed('transition')));
  }

  lockSlide(event) {
    this.slidesLocked = true;
    this.pauseLoop();
    this.specificSlideBlock(event);
    this.selectedHeight(event);
  }

  unlockSlide() {
    this.slidesLocked = false;
    this.startLoop();
  }

  setWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth;
  }

  setupSlides() {
    this.slides = $('.slideshow-slide', this.$el);
    this.slideCount = this.slides.length;

    this.pagination.find('span:first').addClass('active');

    if (!Modernizr.csstransforms) {
      const paginationWidth = this.pagination.width();
      this.pagination.css({ marginLeft: -(paginationWidth / 2) });
    }

    imagesLoaded(this.$el[0], () => {
      for (let i = 0; i < this.slides.length; i++) {
        let slide = this.slides[i];
        slide = $(slide);
        const slideID = slide.attr('id');
        const image = slide.find('.slide-image');
        const imageHeight = image.height();

        slide.data('height', imageHeight);

        const slideHeight = this.windowWidth <= 540 ? slide.height() : imageHeight;

        if (!Modernizr.csstransforms) {
          const slideContent = slide.find('.slide-content');
          const textHeight = slideContent.height();
          slideContent.css({ marginTop: -(textHeight / 2) });
        }

        if (i === 0) {
          slide.addClass('active');

          $('.home-slideshow', this.$el).height(slideHeight);
          this.navigation.css({ paddingTop: `${(imageHeight - 48) / 2}px` });

          this.resetPaginationPosition(imageHeight);
        }

        if ((i + 1) === this.slideCount) {
          $('.home-slideshow', this.$el).addClass('slides-ready');
        }
      }

      $(window).on('resize', () => {
        this.setWindowWidth();
        this.resetSlideHeights();
      });

      if (this.autoplay > 0) {
        this.delay = parseInt(this.autoplay, 10) * 1000;

        this.startLoop();
      }
    });
  }

  resetSlideHeights() {
    this.slides.each((index, slide) => {
      slide = $(slide);

      const image = slide.find('.slide-image');
      const imageHeight = image.height();
      slide.css('height', '');

      slide.data('height', imageHeight);

      const slideHeight = this.windowWidth <= 540 ? slide.height() : imageHeight;

      if (slide.hasClass('active')) {
        $('.home-slideshow', this.$el).height(slideHeight);
        this.navigation.css({ paddingTop: `${(imageHeight - 48) / 2}px` });

        this.resetPaginationPosition(imageHeight);
      }
    });
  }

  selectedHeight(event) {
    imagesLoaded(event.target, () => {
      this.timeouts.push(setTimeout((() => {
        $('.slideshow-slide', this.$el).removeClass('active');
        $(event.target).addClass('active');

        const imageHeight = $(event.target).height();

        $('.home-slideshow', this.$el).css({ height: ($(event.target).height()) });

        this.navigation.css({ paddingTop: `${(imageHeight - 48) / 2}px` });
      }), 500));
    });
  }

  resetPaginationPosition(height) {
    if (this.windowWidth <= 540) {
      this.pagination.css({
        bottom: 'auto',
        top: height - 50,
      });
    }
    this.pagination.css({
      bottom: 0,
      top: 'auto',
    });
  }

  previousSlide(e) {
    if (this.sliding) { return; }
    this.showNewSlide('prev');
    e.preventDefault();
  }

  nextSlide(e) {
    if (this.sliding) { return; }
    this.showNewSlide('next');
    if (e) { e.preventDefault(); }
  }

  specificSlideBlock(event) {
    const nextSlideID = $(event.target).data('slide-id');
    this.showNewSlide('next', nextSlideID);
  }

  specificSlide(event) {
    if (!$(event.currentTarget).hasClass('active')) {
      const nextSlideID = $(event.currentTarget).data('slide-id');
      this.showNewSlide('next', nextSlideID);
    }
  }

  updateSlidePagination(index) {
    this.pagination.find('.active').removeClass('active');
    this.pagination.find('> span').eq(index).addClass('active');
  }

  showNewSlide(type, specificSlide) {
    this.sliding = true;
    let called = false;

    if (this.slides.length === 1) {
      this.sliding = false;
      return;
    }

    const direction = type === 'next' ? 'left' : 'right';
    const fallback = type === 'next' ? 'first' : 'last';

    const activeSlide = $('.slideshow-slide.active', this.$el);
    let nextSlide = specificSlide ? $(`#${specificSlide}`, this.$el) : activeSlide[type]();

    nextSlide = nextSlide.length ? nextSlide : this.slides[fallback]();

    nextSlide.addClass(type);
    nextSlide[0].offsetWidth; // force reflow
    activeSlide.addClass(direction);
    nextSlide.addClass(direction);

    if (Modernizr.csstransitions) {
      nextSlide.one(this.transitionend, () => {
        called = true;
        nextSlide.removeClass([type, direction].join(' ')).addClass('active');
        activeSlide.removeClass(['active', direction].join(' '));
        this.sliding = false;
      });

      // Sometimes on mobile, the swiping will cause the transitionend event
      // to not fire. Trigger it here, just after it should have ended.
      this.timeouts.push(setTimeout(() => {
        if (!called) {
          nextSlide.trigger(this.transitionend);
        }
      },
      300 + 10)); // 0.3s is our transition duration
    } else {
      nextSlide.removeClass([type, direction].join(' ')).addClass('active');
      activeSlide.removeClass(['active', direction].join(' '));
      this.sliding = false;
    }

    const imageHeight = nextSlide.data('height');

    this.updateSlidePagination(nextSlide.index());
    this.resetPaginationPosition(imageHeight);

    this.navigation.css({ paddingTop: `${(imageHeight - 48) / 2}px` });

    const slideHeight = this.windowWidth <= 720 ? nextSlide.height() : imageHeight;

    const slideID = nextSlide.attr('id');
    $('.home-slideshow', this.$el)
      .height(slideHeight);
  }

  startLoop() {
    if (this.autoplay > 0) {
      if (!this.loop) {
        this.loop = true;
        this.autoplayInt = setInterval(() => this.nextSlide(),
          this.delay);
      }
    }
  }

  pauseLoop() {
    this.loop = false;
    clearInterval(this.autoplayInt);
  }

  onSectionBlockSelect(data) {
    const event = {
      target: data.el,
    };

    this.lockSlide(event);
  }

  onSectionBlockDeselect() {
    this.unlockSlide();
  }

  onSectionUnload() {
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    clearInterval(this.autoplayInt);
    this._unbindEvents();
  }
}
